<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Stipend Reports</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSlected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedBranch"
            >
              <option value="">Select Branch</option>
              <option *ngFor="let branch of branchList" [ngValue]="branch">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Profile Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedProfile"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [value]="closing.id"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="exportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>

      <!-- <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
          <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
        </button>
      </div> -->
    </div>
  </div>
</div>

<div class="container pt-3" id="mainContent"  *ngFor="let stipend of reportList">

  <div class="row justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>

  <div class="row">
    <label class="col-sm-4 col-form-label">{{ stipend.branch }}</label>
  </div>

  <div class="row col-md-12">
    <table class="table table-sm table-bordered " style="display: block; overflow-x: auto; white-space: nowrap">
      <tr>
        <th colspan="4"></th>
        <th colspan="3" style="text-align: center">Period of Articleship</th>
        <th></th>
        <th colspan="2">Penalty</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      <tr>
        <th>Reporting Partner</th>
        <th>Article Name</th>
        <th>Article Type</th>
        <th>ICAI Registration Date</th>
        <th>Articleship End Date</th>
        <th>Year</th>
        <th>Month</th>
        <th>Days</th>
        <th>Amount Of Stipned</th>
        <th>Late Diary Submission Penalty</th>
        <th>Late Leave submissio</th>
        <th>Conveyance</th>
        <th>Scholarship</th>
        <th>Advance Travelling Allowance</th>
        <th>Total Travelling Amount</th>
        <th>Net Amount Payable</th>
      </tr>
      <tbody *ngFor="let partner of stipend.partner">
        <tr
          *ngFor="
            let stipendDetail of partner.stipendDetails;
            let i = index;
            let l = count
          "
        >
          <td *ngIf="i === 0 && l > 1">
            {{ partner.partnerFName }} {{ partner.partnerLName }}
          </td>
          <td *ngIf="i === 0 && l === 1">
            {{ partner.partnerFName }} {{ partner.partnerLName }}
          </td>
          <td *ngIf="i != 0 && i != l - 1"></td>
          <td *ngIf="i > 0 && i === l - 1"></td>
          <td>{{ stipendDetail.firstName }} {{ stipendDetail.lastName }}</td>
          <td>{{ stipendDetail.articleType }}</td>
          <td>{{ stipendDetail.icaiRegistrationDate | date: "dd-MMM-yyy" }}</td>
          <td>{{ stipendDetail.articleshipEndDate | date: "dd-MMM-yyy" }}</td>
          <td>{{ stipendDetail.year }}</td>
          <td>{{ stipendDetail.month }}</td>
          <td>{{ stipendDetail.days }}</td>
          <td>{{ stipendDetail.stipend }}</td>
          <td>{{ stipendDetail.diaryPenalty }}</td>
          <td>{{ stipendDetail.leavePenalty }}</td>
          <td>{{ stipendDetail.conveyance }}</td>
          <td>{{ stipendDetail.scholarship }}</td>
          <td>{{ stipendDetail.travelAdvance }}</td>
          <td>{{ stipendDetail.totalTravelAmount }}</td>
          <td>{{ stipendDetail.netPayableAmount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>